import { Component, Inject, OnInit, ViewChild, ViewEncapsulation, HostListener, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { DatePipe } from '@angular/common';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { SharedService } from 'src/app/service/shared/shared.service';
import { FormBuilder } from '@angular/forms';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { saveAs } from 'file-saver';
import { TooltipComponent } from 'src/app/shared/tooltip/tooltip.component';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { ToastrService } from 'ngx-toastr';
import { DwmGenericServiceService, TableState } from '../../_DWM-Generic-Services/generic-service.service';
import { forkJoin } from 'rxjs';
import { GenericService } from 'src/app/services/genericService/generic.service';
import { GetCompanyAndUsersData } from 'src/app/services/get-company-and-users-data/get-company-and-users-data.service';

export interface DwmdashboardPopupData {
  counterName: string;
  btn2?: string;
  btn2BgColor?: string;
  showSuccessIcon?: boolean;
  showSuccessMessage?: boolean;
  showCloseIcon?: boolean;
  title?: string;
  count?: number;
  year?: string;
  month?: any;
  empDetails?: any;
   plantLocations?: string[];
}
@Component({
  selector: 'app-dwmdashboardpopup',
  templateUrl: './dwmdashboardpopup.component.html',
  styleUrls: ['./dwmdashboardpopup.component.scss']
})
export class DwmdashboardpopupComponent implements OnInit {
  pmsYears: any = [];
  selectedYearForDWM: any = null;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  isSubmitted: boolean = true;
  searchTerm: string = '';
  fromYear: any;
  toYear: any;
  selectedYear: any;
  isCurrentYearSelected: boolean = false;
  currentPageNumber: any = 1;
  filteredMonthsList: string[] = [];
  howingOfCount: any = 0;
  showingCount: any = 1;
  totalTaskCount: any;
  selectedSizeOfTask: any = 25;
  showingOfCount: any = 0;
  totalTaskPages: any = 0;
  selectedMonthForDWM: string = '';
  isManagerOrHOD: boolean = false;
  counterName = '';
  monthsList: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  searchTaskString: any = null;
  userIsAdminTypes: any = null;
  dwmAdminData: any;
  adminUserIds: any[] = [];
  plantLocations: string[] = [];

  constructor(
    private elementRef: ElementRef,
    private fb: FormBuilder,
    private httpService: HttpService,
    private config: Config,
    private datePipe: DatePipe,
    private encryptionService: EncryptionService,
    private toastr: ToastrService,
    private dataRefreshService: DataRefreshService,
    public dialog: MatDialog,
    public dwmGenericServiceService: DwmGenericServiceService,
    public mobileResponsiveService: MobileResponsiveService,
    public sharedService: SharedService,
    public genericService: GenericService,
    private getCompanyAndUserData: GetCompanyAndUsersData,
    public dialogRef: MatDialogRef<DwmdashboardpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DwmdashboardPopupData
  ) {}

  ngOnInit() {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == 'Employee') {
          this.loggedInUserRoleIsEmployee = true;
        }
      }
    }
    this.isManagerOrHOD = this.loggedInUserRoles.some((role: any) => role.displayName === 'Manager' || role.displayName === 'HOD');
    this.userIsAdminTypes = this.dwmGenericServiceService.checkIsLoggedInUserIsAdmin();
    if (this.userIsAdminTypes?.userIsAdmin) {
      const request = { companyId: this.loggedInUserCompanyID, search: null, loggedInUserRole: 'Admin' };
      this.httpService.callPostService(this.config.searchAccess + '?sort=id' + ',asc', request).subscribe({
        next: (data: any) => {
          if (data?.status) {
            this.dwmAdminData = data?.data?.access[0] || [];
            this.adminUserIds = this.dwmAdminData?.employeeDetails.map((e: any) => e.employeeId);
          }
        }
      });
    }

    this.counterName = this.data?.counterName || '';
    if (this.data?.year) {
      this.selectedYearForDWM = this.data.year;
    }

    if (this.data?.month) {
      this.selectedMonthForDWM = this.data.month;
    }
      this.plantLocations = this.data?.plantLocations || [];
console.log('data received from dashboard:', this.data);
    this.getpmsyearlist();
  }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      console.log('testing pmsYears:', this.pmsYears);
      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
    });
  }

  // --------------- Set Selected Year -----------------

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForDWM = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.getYearSetupForDWM(this.selectedYearForDWM);
       this.callApiByCounter();
      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }



  callApiByCounter() {
  switch (this.counterName) {

    case 'DWM Submitted':
      this.getHrSubmittedTask();
      break;

    case 'DWM Approved':
      this.getHrApprovedTask();
      break;

    case 'Total R&D Hours Logged':
      this.getHrRnDDurationTask();
      break;

    case 'Avg Compliance Score':
      this.getComplainceScore();
      if (this.isManagerOrHOD) {
        this.getManagerComplianceScore();
      }
      break;

    case 'Count of Task Sent':
    case 'Count of Task Approved':
      this.getManagerSubmitApprovedTask();
      break;

    case 'Done on Time':
    case 'Done with Delay':
    case 'Incomplete After Due Date':
    case 'Not Completed':
      this.getStatusBreakdown();
      break;

    case 'Total Duration Worked':
    case 'Total Duration Worked(R&D)':
      this.getRNDEMployeeManager();
      break;

    default:
      console.warn('No API mapped for:', this.counterName);
  }
}
  // --------------- Get Year Setup For DWM -----------------

  getYearSetupForDWM(year: any) {
    this.selectedYearForDWM = year;
    // this.selectedYear = year;
    this.selectedYear = this.selectedYearForDWM;

    const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
    // console.log("Company Fiscal Year..", this.loggedInCompanyFiscalyear)
    const currentFiscalYear = `${fiscalStartYear}-${fiscalEndYear}`;
    // console.log("Current Fiscal Year...", currentFiscalYear)
    this.isCurrentYearSelected = year === currentFiscalYear;
    this.filterMonthsByFiscalYear(year);
    // this.getHrSubmittedTask();
    // this.getHrApprovedTask();
    // this.getHrRnDDurationTask();
    // this.getComplainceScore();
    // this.getManagerSubmitApprovedTask();
    // this.getManagerComplianceScore();
    // this.getStatusBreakdown();
    // this.getRNDEMployeeManager();
    this.currentPageNumber = 1;
  }

  // getDwmYear(): number {
  //   if (!this.selectedMonthForDWM || !this.filteredMonthsList?.length) {
  //     return Number(this.selectedYearForDWM.split('-')[0]);
  //   }

  // console.log('selectedYearForDWM:', this.selectedYearForDWM);
  //   console.log('selectedMonthForDWM:', this.selectedMonthForDWM);
  //     console.log('filteredMonthsList:', this.filteredMonthsList);
  //   const [startYear, endYear] = this.selectedYearForDWM.split('-').map(Number);
  //   const fiscalStartMonth = this.filteredMonthsList[0];

  //   return this.monthsList.indexOf(this.selectedMonthForDWM) < this.monthsList.indexOf(fiscalStartMonth) ? endYear : startYear;
    
  // }
  getDwmYear(): number {
  const yearRange = this.data?.year || this.selectedYearForDWM;
  const month = this.data?.month || this.selectedMonthForDWM;

  if (!month || !this.filteredMonthsList?.length) {
    return Number(yearRange.split('-')[0]);
  }

  const [startYear, endYear] = yearRange.split('-').map(Number);
  const fiscalStartMonth = this.filteredMonthsList[0];

  const selectedMonthIdx = this.monthsList.indexOf(month);
  const fiscalStartIdx = this.monthsList.indexOf(fiscalStartMonth);

  // month BEFORE fiscal start = endYear, month AFTER fiscal start = startYear
  return selectedMonthIdx < fiscalStartIdx ? endYear : startYear;
}

  filterMonthsByFiscalYear(selectedYear: string) {
    const fiscal = this.loggedInCompanyFiscalyear;
    const [startMon, endMon] = fiscal.split('_');

    const monthIndex = (mon: string) => new Date(`${mon} 1, 2000`).getMonth();

    const startIdx = monthIndex(startMon);
    const endIdx = monthIndex(endMon);

    this.filteredMonthsList = startIdx <= endIdx ? this.monthsList.slice(startIdx, endIdx + 1) : [...this.monthsList.slice(startIdx), ...this.monthsList.slice(0, endIdx + 1)];
    const currentMonth = new Date().toLocaleString('default', {
      month: 'long'
    });

    // this.selectedMonthForDWM = this.isCurrentYearSelected && this.filteredMonthsList.includes(currentMonth) ? currentMonth : '';
    if (!this.selectedMonthForDWM) {
      this.selectedMonthForDWM = this.isCurrentYearSelected && this.filteredMonthsList.includes(currentMonth) ? currentMonth : '';
    }
  }

  changeData() {}

  // ------------------------------------------------ Sort Ascending ---------------------------------------------

  onSortAssending(name: any) {}

  // ------------------------------------------------ Sort Descending ---------------------------------------------

  onSortDesending(name: any) {}

  // ------------------------------------------------Pagination ---------------------------------------------

  onSelectSizeCount() {
    this.currentPageNumber = 1;
  }

  previousPageTask() {
    if (this.currentPageNumber > 1) {
      this.currentPageNumber--;
    }
  }

  nextPageTask() {
    if (this.currentPageNumber < this.totalTaskPages) {
      this.currentPageNumber++;
    }
  }

  exportTableToPDF(): void {}

  taskList: any;
  exportToExcel(): void {
    // if (!this.taskList || this.taskList.length === 0) {
    //   this.toastr.warning('No task data to export!');
    //   return;
    // }
    // const data = this.taskList.map((task) => {
    //   return {
    //     Category: task.categoryId || '',
    //     Actionable: task.actionable || '',
    //     'Time From': task.timeFrom || '',
    //     'Time To': task.timeTo || '',
    //     'Repetitive Task': task.isRepetativeTask ? 'Yes' : 'No',
    //     Frequency: task.dwmFrequency || '',
    //     Date: task.dwmDate
    //       ? this.datePipe.transform(task.dwmDate, 'dd/MM/yyyy')
    //       : '',
    //     Status: task.status || 'Pending',
    //   };
    // });

    // Create worksheet and workbook
    const data = this.taskList;
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'DWM Tasks');
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });
    this.saveAsExcelFile(excelBuffer, `DWM_Tasks`);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '-'); // dd-mm-yyyy
    saveAs(data, `${fileName}-${formattedDate}.xlsx`);
  }

  // ------------------------------ On Toggle switch ---------------------
  type: string = '';
  isToggleOn: boolean = true;
  onChangeSwitch(event: any) {
    this.isToggleOn = event?.checked;

    if (this.counterName === 'Avg Compliance Score') {
      this.complianceTableData = this.isToggleOn ? this.byDepartment : this.byGrade;
      return;
    }

    if (this.counterName === 'Total R&D Hours Logged') {
      this.durationRnDEmployee = this.isToggleOn ? this.productWiseData : this.departmentWiseData;
      // console.log('Checking ....', this.durationRnDEmployee);
      return;
    }
    if (event?.checked == true) {
      this.type = 'Submitted';
      if ((this.counterName == 'DWM Submitted' || this.counterName == 'DWM Approved') && event?.checked == true) {
        this.type = 'Approved';
      }
      // this.getDashboardList()
    } else if (event?.checked == false) {
      this.type = 'Not Submitted';
      if ((this.counterName == 'DWM Submitted' || this.counterName == 'DWM Approved') && event?.checked == false) {
        this.type = 'Not Approved';
      }
      // this.getDashboardList()
    }
    this.applySubmittedFilter();
  }

  // ---------------------------------- DWM Submitted details (HR) ----------------------------------------------------
  submittedTaskEmployee: any[] = [];
  allSubmittedTaskEmployee: any[] = [];
  getHrSubmittedTask() {
    const monthNumber = this.monthsList.indexOf(this.selectedMonthForDWM) + 1;

    let payload: any = this.data?.empDetails
      ? this.data?.empDetails
      : {
          companyId: this.loggedInUserCompanyID,
          year: this.getDwmYear(),
          month: monthNumber,
          plantLocations: this.plantLocations 
        };

          console.log('FINAL PAYLOAD:', payload);
    // let payload: any = {
    //   companyId: this.loggedInUserCompanyID,
    //   year: this.getDwmYear(),
    //   month: monthNumber
    // };
    // const apiAndPayload = this.userIsAdminTypes?.userIsAdmin ? this.httpService.callPostService(this.config.adminSubmittedTask, payload) : this.httpService.callPostService(this.config.getHrSubmittedTaskDetails, payload);
    // apiAndPayload.subscribe((data: any) => {
    //   this.allSubmittedTaskEmployee = data?.data || [];
    //   this.applySubmittedFilter();
    // });

    if (this.userIsAdminTypes?.userIsAdmin) {
      const request = { companyId: this.loggedInUserCompanyID, search: null, loggedInUserRole: 'Admin' };
      this.httpService.callPostService(this.config.searchAccess + '?sort=id' + ',asc', request).subscribe({
        next: (data: any) => {
          if (data?.status) {
            this.dwmAdminData = data?.data?.access[0] || [];
            if (!this.data?.empDetails) payload.userIds = this.dwmAdminData?.employeeDetails.map((e: any) => e.employeeId);
            // payload.userIds = this.dwmAdminData?.employeeDetails.map((e: any) => e.employeeId);

            this.httpService.callPostService(this.config.adminSubmittedTask, payload).subscribe((data: any) => {
              this.allSubmittedTaskEmployee = data?.data?.submittedTaskResponses || [];
              this.applySubmittedFilter();
            });
          }
        }
      });
    } else {
      this.httpService.callPostService(this.config.getHrSubmittedTaskDetails, payload).subscribe((data: any) => {
        this.allSubmittedTaskEmployee = data?.data || [];
        this.applySubmittedFilter();
      });
    }
  }

  applySubmittedFilter() {
    // console.log('this.filteredApprovedTaskEmployee ', this.filteredApprovedTaskEmployee);
    if (this.counterName == 'DWM Approved') {
      this.filteredApprovedTaskEmployee = [];
      setTimeout(() => {
        if (this.isToggleOn) {
          this.filteredApprovedTaskEmployee = this.allApprovedTaskEmployee.slice().filter((item: any) => Number(item?.noOfApprovedTasks || 0) > 0);
        } else {
          this.filteredApprovedTaskEmployee = this.allApprovedTaskEmployee.slice().filter((item: any) => Number(item?.noOfPendingTasks || 0) > 0);
        }
      }, 500);

      return;
    }

    if (this.counterName !== 'DWM Submitted') {
      this.submittedTaskEmployee = this.allSubmittedTaskEmployee;
      return;
    }

    

    // if (this.isToggleOn) {
    //   // Toggle ON → Submitted → Pending
    //   this.submittedTaskEmployee = this.allSubmittedTaskEmployee.filter(item => item?.status === 'Pending');
    //   // console.log('pending data is......', this.submittedTaskEmployee);
    // } else {
    //   // Toggle OFF → Not Submitted → Draft
    //   this.submittedTaskEmployee = this.allSubmittedTaskEmployee.filter(item => item?.status === 'Draft');
    //   // console.log('Draft data is ...', this.submittedTaskEmployee);
    // }

    if (this.isToggleOn) {
      //  Submitted toggle → show records where submittedCount > 0
      this.submittedTaskEmployee = this.allSubmittedTaskEmployee.filter(item => Number(item?.submittedCount || 0) > 0);
    } else {
      //  Not Submitted toggle → show records where submittedCount == 0 (includes draftCount 0 and > 0)
      this.submittedTaskEmployee = this.allSubmittedTaskEmployee.filter(item => Number(item?.submittedCount || 0) === 0);
    }
  }

  // ---------------------------------- DWM Approved details (HR) ----------------------------------------------------
  filteredApprovedTaskEmployee: any[] = [];
  allApprovedTaskEmployee: any[] = [];
  getHrApprovedTask() {
    const monthNumber = this.monthsList.indexOf(this.selectedMonthForDWM) + 1;

    let payload: any = this.data?.empDetails
      ? this.data?.empDetails
      : {
          companyId: this.loggedInUserCompanyID,
          year: this.getDwmYear(),
          month: monthNumber,
          plantLocations: this.plantLocations
        };
    // const payload: any = {
    //   companyId: this.loggedInUserCompanyID,
    //   year: this.getDwmYear(),
    //   month: monthNumber
    // };
    // if (this.userIsAdminTypes?.userIsAdmin) payload.userIds = this.adminUserIds;
    // const apiAndPayload = this.userIsAdminTypes?.userIsAdmin ? this.httpService.callPostService(this.config.adminApprovedTask, payload) : this.httpService.callPostService(this.config.getHrApprovedTaskDetails, payload);
    // apiAndPayload.subscribe((data: any) => {
    //   this.allApprovedTaskEmployee = data?.data || [];
    //   //  this.applySubmittedFilter();
    //   console.log('Hr Approved task ....', this.submittedTaskEmployee);
    // });

    if (this.userIsAdminTypes?.userIsAdmin) {
      const request = { companyId: this.loggedInUserCompanyID, search: null, loggedInUserRole: 'Admin' };
      this.httpService.callPostService(this.config.searchAccess + '?sort=id' + ',asc', request).subscribe({
        next: (data: any) => {
          if (data?.status) {
            this.dwmAdminData = data?.data?.access[0] || [];
            // payload.userIds = this.dwmAdminData?.employeeDetails.map((e: any) => e.employeeId);
            if (!this.data?.empDetails) payload.userIds = this.dwmAdminData?.employeeDetails.map((e: any) => e.employeeId);
            this.httpService.callPostService(this.config.adminApprovedTask, payload).subscribe((data: any) => {
              this.allApprovedTaskEmployee = data?.data?.approvedTaskResponses || [];
              this.filteredApprovedTaskEmployee = this.allApprovedTaskEmployee.slice();
              // this.applySubmittedFilter();
            });
          }
        }
      });
    } else {
      this.httpService.callPostService(this.config.getHrApprovedTaskDetails, payload).subscribe((data: any) => {
        this.allApprovedTaskEmployee = data?.data || [];
        this.filteredApprovedTaskEmployee = this.allApprovedTaskEmployee.slice();
        // this.applySubmittedFilter();
      });
    }
  }

  applyApprovedFilter() {
    if (this.counterName !== 'DWM Submitted') {
      this.submittedTaskEmployee = this.allSubmittedTaskEmployee;
      return;
    }

    if (this.isToggleOn) {
      // Toggle ON → Submitted → Pending
      this.submittedTaskEmployee = this.allSubmittedTaskEmployee.filter(item => item?.status === 'Pending');
      // console.log('pending data is......', this.submittedTaskEmployee);
    } else {
      // Toggle OFF → Not Submitted → Draft
      this.submittedTaskEmployee = this.allSubmittedTaskEmployee.filter(item => item?.status === 'Draft');
      // console.log('Draft data is ...', this.submittedTaskEmployee);
    }
  }

  // -------------------------------------------- R&D Duration counter details -------------------
  durationRnDEmployee: any[] = [];
  productWiseData: any[] = [];
  departmentWiseData: any[] = [];

  getHrRnDDurationTask() {
    const monthNumber = this.monthsList.indexOf(this.selectedMonthForDWM) + 1;

    let payload: any = this.data?.empDetails
      ? this.data?.empDetails
      : {
          companyId: this.loggedInUserCompanyID,
          year: this.getDwmYear(),
          month: monthNumber,
          plantLocations: this.plantLocations
        };
    // const payload: any = {
    //   companyId: this.loggedInUserCompanyID,
    //   year: this.getDwmYear(),
    //   month: monthNumber
    // };
    // if (this.userIsAdminTypes?.userIsAdmin) payload.userIds = this.adminUserIds;
    // const apiAndPayload = this.userIsAdminTypes?.userIsAdmin ? this.httpService.callPostService(this.config.adminRnDDuration, payload) : this.httpService.callPostService(this.config.getHrRnDDurationTaskDetails, payload);
    // apiAndPayload.subscribe((data: any) => {
    //   this.productWiseData = data?.data || [];
    //   this.prepareDepartmentWiseData(this.productWiseData);
    //   this.durationRnDEmployee = this.productWiseData;
    // });

    if (this.userIsAdminTypes?.userIsAdmin) {
      const request = { companyId: this.loggedInUserCompanyID, search: null, loggedInUserRole: 'Admin' };
      this.httpService.callPostService(this.config.searchAccess + '?sort=id' + ',asc', request).subscribe({
        next: (data: any) => {
          if (data?.status) {
            this.dwmAdminData = data?.data?.access[0] || [];
            // payload.userIds = this.dwmAdminData?.employeeDetails.map((e: any) => e.employeeId);
            if (!this.data?.empDetails) payload.userIds = this.dwmAdminData?.employeeDetails.map((e: any) => e.employeeId);
            this.httpService.callPostService(this.config.adminRnDDuration, payload).subscribe((data: any) => {
              this.productWiseData = data?.data?.rnDUsersDetails || [];
              this.prepareDepartmentWiseData(this.productWiseData);
              this.durationRnDEmployee = this.productWiseData;
            });
          }
        }
      });
    } else {
      this.httpService.callPostService(this.config.getHrRnDDurationTaskDetails, payload).subscribe((data: any) => {
        this.productWiseData = data?.data || [];
        this.prepareDepartmentWiseData(this.productWiseData);
        this.durationRnDEmployee = this.productWiseData;
      });
    }
  }

  // prepareDepartmentWiseData(data: any[]) {
  //   const map = new Map<string, any>();

  //   data.forEach(item => {
  //     const dept = item.department;

  //     if (!map.has(dept)) {
  //       map.set(dept, {
  //         department: dept,
  //         totalHours: 0,
  //         noOfEmployees: 0
  //       });
  //     }

  //     const obj = map.get(dept);
  //     obj.totalHours += Number(item.totalHours);

  //     obj.noOfEmployees += Number(item.noOfEmployees);
  //   });

  //   this.departmentWiseData = Array.from(map.values()).map(d => ({
  //     ...d,
  //     averageHoursOfEmployees: d.noOfEmployees ? (d.totalHours / d.noOfEmployees).toFixed(2) : 0
  //   }));
  //   console.log('Hours are .....', this.departmentWiseData);
  // }

  prepareDepartmentWiseData(data: any[]) {
    const map = new Map<string, any>();

    data.forEach(item => {
      const dept = item.department;

      // convert HH:mm to minutes
      const [hours, minutes] = item.totalHours.split(':').map(Number);
      const totalMinutes = hours * 60 + minutes;

      if (!map.has(dept)) {
        map.set(dept, {
          department: dept,
          totalMinutes: 0,
          noOfEmployees: 0
        });
      }

      const obj = map.get(dept);
      obj.totalMinutes += totalMinutes;
      obj.noOfEmployees += Number(item.noOfEmployees);
    });

    this.departmentWiseData = Array.from(map.values()).map(d => {
      const avgMinutes = d.noOfEmployees ? Math.floor(d.totalMinutes / d.noOfEmployees) : 0;

      // convert total back to HH:mm
      const totalHrs = Math.floor(d.totalMinutes / 60);
      const totalMins = d.totalMinutes % 60;

      // convert average back to HH:mm
      const avgHrs = Math.floor(avgMinutes / 60);
      const avgMins = avgMinutes % 60;

      return {
        department: d.department,
        totalHours: `${totalHrs}:${totalMins.toString().padStart(2, '0')}`,
        noOfEmployees: d.noOfEmployees,
        averageHoursOfEmployees: `${avgHrs}:${avgMins.toString().padStart(2, '0')}`
      };
    });

    // console.log('Hours are .....', this.departmentWiseData);
  }

  // -------------------------------------------- Compliance Score counter details -------------------
  byDepartment: any[] = [];
  byGrade: any[] = [];
  complianceTableData: any[] = [];

  getComplainceScore() {
    const monthNumber = this.monthsList.indexOf(this.selectedMonthForDWM) + 1;

    let payload: any = this.data?.empDetails
      ? this.data?.empDetails
      : {
          companyId: this.loggedInUserCompanyID,
          year: this.getDwmYear(),
          month: monthNumber,
          plantLocations: this.plantLocations
        };
    // const payload: any = {
    //   companyId: this.loggedInUserCompanyID,
    //   year: this.getDwmYear(),
    //   month: monthNumber
    // };
    // if (this.userIsAdminTypes?.userIsAdmin) payload.userIds = this.adminUserIds;
    // const apiAndPayload = this.userIsAdminTypes?.userIsAdmin ? this.httpService.callPostService(this.config.adminComplianceScore, payload) : this.httpService.callPostService(this.config.getHrComplianceScoreDetails, payload);
    // apiAndPayload.subscribe((data: any) => {
    //   this.byDepartment = data?.data?.byDepartment || [];
    //   this.byGrade = data?.data?.byGrade || [];
    //   this.complianceTableData = this.byDepartment;
    // });

    if (this.userIsAdminTypes?.userIsAdmin) {
      const request = { companyId: this.loggedInUserCompanyID, search: null, loggedInUserRole: 'Admin' };
      this.httpService.callPostService(this.config.searchAccess + '?sort=id' + ',asc', request).subscribe({
        next: (data: any) => {
          if (data?.status) {
            this.dwmAdminData = data?.data?.access[0] || [];
            // payload.userIds = this.dwmAdminData?.employeeDetails.map((e: any) => e.employeeId);
            if (!this.data?.empDetails) payload.userIds = this.dwmAdminData?.employeeDetails.map((e: any) => e.employeeId);
            // console.log(payload);
            this.httpService.callPostService(this.config.adminComplianceScore, payload).subscribe((data: any) => {
              this.byDepartment = data?.data?.byDepartment || [];
              this.byGrade = data?.data?.byGrade || [];
              this.complianceTableData = this.byDepartment;
            });
          }
        }
      });
    } else {
      this.httpService.callPostService(this.config.getHrComplianceScoreDetails, payload).subscribe((data: any) => {
        this.byDepartment = data?.data?.byDepartment || [];
        this.byGrade = data?.data?.byGrade || [];
        this.complianceTableData = this.byDepartment;
      });
    }
  }

  // ------------------------------------------- Count of task sent & Approved(Manager) ---------------------------
  submitApprovedTask: any[] = [];

  getManagerSubmitApprovedTask(item?: any) {
    const monthNumber = this.monthsList.indexOf(this.selectedMonthForDWM) + 1;

    const payload: any = {
      companyId: this.loggedInUserCompanyID,
      year: this.getDwmYear(),
      month: monthNumber,
      userId: null,
      managerId: this.loggedInUserRole == 'Employee' ? item.managerId : this.loggedInUserId
    };

    this.httpService.callPostService(this.config.getManagerSubmitedApprovedDetails, payload).subscribe((data: any) => {
      this.submitApprovedTask = data?.data || [];
      // console.log('Hr Approved task ....', this.submittedTaskEmployee);
    });
  }

  // ------------------------------- Manager Compliance score --------------------------
  managerComplainceData: any[] = [];
  getManagerComplianceScore(item?: any) {
    const monthNumber = this.monthsList.indexOf(this.selectedMonthForDWM) + 1;

    const payload: any = {
      companyId: this.loggedInUserCompanyID,
      year: this.getDwmYear(),
      month: monthNumber,
      userId: null,
      managerId: this.loggedInUserRole == 'Employee' ? Number(item?.managerId) : Number(this.loggedInUserId)
    };

    this.httpService.callPostService(this.config.getManagerComplainceScoreDetails, payload).subscribe((data: any) => {
      this.managerComplainceData = data?.data || [];
      // console.log('Hr Approved task ....', this.submittedTaskEmployee);
    });
  }

  // -------------------------- Manager Task status breakdown counter ---------------------------------------

  statusBreakdownData: any[] = [];

  getStatusBreakdown(item?: any) {
    const monthNumber = this.monthsList.indexOf(this.selectedMonthForDWM) + 1;

    const payload: any = {
      companyId: this.loggedInUserCompanyID,
      year: this.getDwmYear(),
      month: monthNumber,
      userId: null,
      managerId: this.loggedInUserRole == 'Employee' ? item.managerId : this.loggedInUserId
    };

    this.httpService.callPostService(this.config.getManagerTaskBreakdownDetails, payload).subscribe((data: any) => {
      this.statusBreakdownData = data?.data || [];
    });
  }

  getStatusValue(item: any): number {
    switch (this.counterName) {
      case 'Done on Time':
        return item?.doneOnTime || 0;

      case 'Done with Delay':
        return item?.doneWithDelay || 0;

      case 'Incomplete After Due Date':
        return item?.incompleteAfterDueDate || 0;

      case 'Not Completed':
        return item?.notStarted || 0;

      default:
        return 0;
    }
  }

  // -------------------------------- R&D total hours (R&D Employee & Manager)---------------------
  employeeMangerRNDDurationData: any[] = [];
  getRNDEMployeeManager(item?: any) {
    const monthNumber = this.monthsList.indexOf(this.selectedMonthForDWM) + 1;
    const isEmployee = this.loggedInUserRole === 'Employee';
    const payload: any = {
      companyId: this.loggedInUserCompanyID,
      year: this.getDwmYear(),
      month: monthNumber,
      userId: isEmployee ? Number(this.loggedInUserId) : null,
      managerId: isEmployee ? null : Number(this.loggedInUserId)
    };

    this.httpService.callPostService(this.config.getRNDEmployeeManagerDetails, payload).subscribe((data: any) => {
      this.employeeMangerRNDDurationData = data?.data || [];
    });
  }

  // -------------------------- Download -------------------------------------

  downloadPDFAndExcel(type: 'excel') {
    if (type !== 'excel') return;

    const config = this.getExcelConfigByCounter();
    if (!config || !config.data?.length) {
      this.toastr.warning('No data available to export!');
      return;
    }

    this.dwmGenericServiceService.saveAsExcelFile(config.data, config.fileName, config.sheetName);
  }

  getExcelConfigByCounter() {
    switch (this.counterName) {
      case 'DWM Submitted':
        const filteredData = this.isToggleOn ? this.allSubmittedTaskEmployee.filter(i => Number(i?.submittedCount || 0) > 0) : this.allSubmittedTaskEmployee.filter(i => Number(i?.submittedCount || 0) === 0);
        // loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'Admin';
        return {
          fileName: 'DWM_Submitted',
          sheetName: 'DWM_Submitted',
          data: filteredData.map(i => {
            const row: any = {
              'Employee Name': i.userName
            };
            if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'Admin') row['Employee ID'] = i.employeeId;
            row['Department'] = i.department;
            row['Grade'] = i.grade;
            row['Plant Location'] = i.plantLocation;
            // 'Submission Date': this.datePipe.transform(i.submissionDate, 'dd-MM-yyyy')

            //  Dynamic column based on toggle
            if (this.isToggleOn) {
              row['Submitted Count'] = i.submittedCount;
            } else {
              row['Not Submitted Count'] = i.draftCount;
            }

            return row;
          })
        };
      case 'DWM Approved':
        return {
          fileName: 'DWM_Approved',
          sheetName: 'DWM_Approved',
          data: this.filteredApprovedTaskEmployee.map(i => {
            const row: any = {
              'Employee Name': i.userName
            };

            if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'Admin') row['Employee ID'] = i.employeeId;
            row['Manager Name'] = i.managerName;
            row['Department'] = i.department;
            row['Grade'] = i.grade;
            row['Plant Location'] = i.plantLocation;
            if (this.isToggleOn) {
              row['Approved Tasks'] = i.noOfApprovedTasks;
            } else {
              row['No of Pending Tasks'] = i.noOfPendingTasks;
            }

            // Include Pending only if toggle is OFF (same as table)
            // if (!this.isToggleOn) {}
            row['No of Rejected Tasks'] = i.noOfRejectedTasks;

            return row;
          })
        };

      case 'Total R&D Hours Logged':
        return {
          fileName: 'Total_R&D_Hours',
          sheetName: 'Total_R&D_Hours_Logged',
          data: this.durationRnDEmployee.map(i => ({
            [this.isToggleOn ? 'Product Number' : 'Department']: this.isToggleOn ? i.productNo : i.department,
            [this.isToggleOn ? 'Product Name' : 'Department']: this.isToggleOn ? i.productName : i.department,
            [this.isToggleOn ? 'plant Location' : 'Department']: this.isToggleOn ? i.plantLocation : i.department,
            [this.isToggleOn ? 'business Unit' : 'Department']: this.isToggleOn ? i.businessUnit : i.department,
            [this.isToggleOn ? 'Customer Name' : 'Department']: this.isToggleOn ? i.customerName : i.department,
            'Total Hours': i.totalHours,  
            'No of Employees': i.noOfEmployees,
            'Avg Hours': i.averageHoursOfEmployees
          }))
        };

      case 'Avg Compliance Score':
        return this.isManagerOrHOD && !(this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'HR Admin')
          ? {
              fileName: 'Compliance_Manager',
              sheetName: 'Avg_Compliance_Score',
              data: this.managerComplainceData.map(i => ({
                'Employee Name': i.userName,
                Department: i.department,
                Grade: i.grade,
                'Compliance %': i.complianceScore
              }))
            }
          : {
              fileName: 'Compliance_HR',
              sheetName: 'Avg_Compliance_Score',
              data: this.complianceTableData.map(i => ({
                [this.isToggleOn ? 'Department' : 'Grade']: this.isToggleOn ? i.department : i.grade,
                  ...(this.isToggleOn &&
            (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin')
            ? { 'Plant Location': i.plantLocation }
            : {}),

                'Avg Compliance %': i.averageComplianceScore,
                'No of Employees': i.noOfEmployees
              }))
            };

      case 'Count of Task Sent':
        return {
          fileName: 'Task_Sent',
          sheetName: 'Count_Of_Task_Sent',
          data: this.submitApprovedTask.map(i => ({
            'Employee Name': i.userName,
            Department: i.department,
            Grade: i.grade,
            'Tasks Sent': i.nofTasksSent
          }))
        };

      case 'Count of Task Approved':
        return {
          fileName: 'Task_Approved',
          sheetName: 'Count_Of_Task_Approved',
          data: this.submitApprovedTask.map(i => ({
            'Employee Name': i.userName,
            Department: i.department,
            Grade: i.grade,
            Approved: i.noOfApprovedTask,
            'Approval %': i.approvalPercentage
          }))
        };
      case 'Done on Time':
      case 'Done with Delay':
      case 'Incomplete After Due Date':
      case 'Not Completed':
        return {
          fileName: this.counterName.replace(/\s+/g, '_'),
          sheetName: 'Task_Status',
          data: this.statusBreakdownData.map(i => ({
            'Employee Name': i.userName,
            [this.counterName]: this.getStatusValue(i)
          }))
        };

      default:
        return null;
    }
  }

  getAdminUsers() {
    // this.filteredDashboardCounters = [];
    // this.applyDashboardCounterFilter();
    // const year = this.getCompanyAndUserData.getYearAsPerSelectedFinancialYearAnddMonth(this.selectedYearForDWM, this.selectedMonthForDWM);
    // const payload = {
    //   companyId: this.loggedInUserCompanyID,
    //   year,
    //   month: this.genericService.getCurrentMonthInNumber(this.selectedMonthForDWM)
    // };
    // forkJoin({
    //   adminSubmittedTask: this.httpService.callPostService(this.config.adminSubmittedTask, payload),
    //   adminApprovedTask: this.httpService.callPostService(this.config.adminApprovedTask, payload),
    //   adminRnDDuration: this.httpService.callPostService(this.config.adminRnDDuration, payload),
    //   adminComplianceScore: this.httpService.callPostService(this.config.adminComplianceScore, payload)
    // }).subscribe({
    //   next: (data: any) => {
    //     console.log(data);
    //     const filterdata: any[] = [];
    //   }
    // });
    // this.dwmAdminData?.employeeDetails;
  }
}
